import React from 'react';

import { Field, FormikErrors, FormikValues } from 'formik';

import { useStyles } from './Themable.hooks';

import TranslationHelper from '../../helpers/TranslationHelper';

import { ICoordinates, ILocationForm } from '../../state/types';

import FieldWrapper from '../../components/common/formikWrappers/FieldWrapper';
import AlertCard from '../../components/alertCard';
import AddressSection from '../../components/AddressSection/AddressSection';
import VisibilityForm from '../../components/VisibilityForm';

interface IOwnProps {
    errors: FormikErrors<ILocationForm>;
    values: FormikValues;
    showAlert: boolean;
    mapCoordinates: ICoordinates | null;
    setFieldValue: (field: string, value: any) => void;
    handleStoreClickPosition: (coords: ICoordinates) => void;
    handleChangeMarkerPosition: (values: FormikValues) => void;
}

const LocationForm = ({
    errors,
    values,
    showAlert,
    mapCoordinates,
    setFieldValue,
    handleStoreClickPosition,
    handleChangeMarkerPosition,
}: IOwnProps) => {
    const classes = useStyles();

    return (
        <div className={classes.formWrapper}>
            {showAlert && (
                <AlertCard
                    message={
                        'Changes to the POI list will only affect the data received after their execution.'
                    }
                    type="info"
                />
            )}

            {mapCoordinates === null && (
                <p>
                    {TranslationHelper.translate(
                        'Click on map to set this location coordinates'
                    )}
                </p>
            )}

            <Field
                className={classes.field}
                error={!!errors?.name}
                helperText={errors?.name}
                name={'name'}
                label={TranslationHelper.translate('Name')}
                fullWidth={true}
                required={true}
                component={FieldWrapper}
            />

            <AddressSection
                mapCoordinates={mapCoordinates}
                errors={errors}
                values={values}
                setFieldValue={setFieldValue}
                callback={handleStoreClickPosition}
                handleChangeMarkerPosition={handleChangeMarkerPosition}
            />
            <VisibilityForm
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
            />

            <Field
                className={classes.field}
                error={!!errors?.notes}
                helperText={errors?.notes}
                name={'notes'}
                label={TranslationHelper.translate('Notes')}
                fullWidth={true}
                component={FieldWrapper}
                multiline={true}
            />
        </div>
    );
};

export default LocationForm;
